export default __webpack_public_path__ + "media/images/front/snsBnr/sp_sns_tab-7cc1a9710b71819e18cadb7f2d520c95.png";